// extracted by mini-css-extract-plugin
module.exports = {"ErrorWrapper":"errorNotice_ErrorWrapper__hxuGB","ErrorDetailes":"errorNotice_ErrorDetailes__3xx-Q"};